"use strict";

exports.__esModule = true;
exports.default = void 0;
var _helpers = require("../../helpers");
var _schema = _interopRequireDefault(require("./schema"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const roleCases = (0, _helpers.JoinReducerHelper)({
  localName: "user",
  foreignName: "group"
});
const permissionCases = (0, _helpers.JoinReducerHelper)({
  localName: "user",
  foreignName: "permission"
});
const licenseCases = (0, _helpers.JoinReducerHelper)({
  localName: "user",
  foreignName: "license"
});
const pictureCases = (0, _helpers.JoinReducerHelper)({
  localName: "user",
  foreignName: "image",
  propName: "UserImage",
  propType: "Object"
});
let list;
const userAndImageCases = {
  GET_IMAGE_REQUEST: state => {
    return {
      ...state,
      list: {
        ...state.list,
        fetching: true,
        fetched: false
      }
    };
  },
  GET_IMAGE_SUCCESS: (state, action) => {
    let img = action.data;
    if (state.list.data) {
      list = {
        ...state.list,
        fetching: false,
        fetched: true,
        error: null,
        data: state.list.data.map((item /* index */) => {
          if (item.Id === img.UserId) {
            return {
              ...item,
              UserImage: img
            };
          } else return item;
        })
      };
    } else list = {
      ...state.list
    };
    return {
      ...state,
      list
    };
  },
  GET_IMAGE_FAILURE: (state, action) => {
    return {
      ...state,
      single: {
        ...state.single,
        fetching: false,
        fetched: true,
        error: action.data
      }
    };
  }
};
/* 
const parseCases = {

    'PARSED_CSV': (state, action) => {

        return {
            ...state,
            parsed: action.users
        }
    },

    'DELETE_PARSED_USER': (state, action) => {

        const parsed = state.parsed.filter(p => p.Email !== action.p.Email)

        return {
            ...state,
            parsed
        }

    }

};
 */
const UserReducer = new _helpers.ReducerHelper({
  singular: "user"
}, {
  ...roleCases,
  ...permissionCases,
  ...licenseCases,
  // ...parseCases,
  ...pictureCases,
  ...userAndImageCases
}, {
  schema: _schema.default
});
const users = (state, action) => {
  return UserReducer.reduce(state, action);
};
var _default = exports.default = users;
module.exports = exports.default;